module.exports = __webpack_public_path__ + "static/media/frederick.e705d4b3.png";